import React from "react";
import Media from "react-media";
import { Subscription } from 'rxjs'
import { AuthService, LoginApiState } from "../../../services/authentication/AuthService";
import { RecaptchaProvider } from "../../../services/authentication/recaptcha-v3/RecaptchaProvider";
import { LoginState } from "../../../states/LoginState";
import { ReactComponent as HelpIcon } from "../../../resources/images/help.svg";
import './LoginMobile.css';
import { Button, TextField } from "@material-ui/core";
import { StringUtils } from "../../../utils/StringUtils";
import { MposLoader } from "../../../components/loader/MposLoader";
import { GoogleTagManagerService } from "../../../services/analitycs/GoogleTagManagerService";
import { MposWebPortalApi } from "../../../services/api/MposWebPortalApi";
import $ from 'jquery';
import { ConfigProvider } from "../../../services/configuration/ConfigProvider";
import { ITerminalsDto } from "../../../models/TerminalsDto";
import { TerminalsUtils } from "../../../utils/TerminalsUtils";
import StateContextProvider from "../../../context/StateContext";

export class LoginMobile extends React.Component<any, LoginState> {
    private recaptcha: RecaptchaProvider;
    private loginObservable: any = null;
    private userLogin: any = null;
    private adminDetailSubscription: any = null;
    private ua = navigator.userAgent.toLowerCase();
    private isAndroid = this.ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
    private config = ConfigProvider.getInstance().getConfiguration();
    private getTerminalsSubscription: any = null;
    private getDevelopersSubscription: Subscription | null = null;

    constructor(props: any) {
        super(props)
        this.state = {
            username: '',
            password: '',
            buttonDisabled: true,
            usernameProvided: false,
            loginError: false,
            showLoader: false,
            loginErrorMessage: "",
            superuserDetailsError: false,
            firstAttempt: true,
            loginOtherAttemptsButtonDisabled: false
        };

        this.handleUsernameChanges = this.handleUsernameChanges.bind(this);
        this.handlePasswordChanges = this.handlePasswordChanges.bind(this);
        this.handleLoginFirstStep = this.handleLoginFirstStep.bind(this);
        this.handleModifyUser = this.handleModifyUser.bind(this);
        this.handleLogin = this.handleLogin.bind(this);

        this.recaptcha = RecaptchaProvider.getInstance();
    }

    componentDidMount() {
        this.setState({ firstAttempt: true });
        setTimeout(() => {
            GoogleTagManagerService.getInstance().pushPageAuthEvent(window.location.pathname, 'Login', null, 'username e password');
        }, 1000);
    }

    // Handlers
    private handleUsernameChanges(event: any) {
        this.setState({ loginError: false });
        this.setState({ username: event.target.value });
        this.setState({ buttonDisabled: !event.target.value });
    }

    private handlePasswordChanges(event: any) {
        this.setState({ loginError: false });
        this.setState({ password: event.target.value });
        this.setState({ buttonDisabled: !event.target.value });
        if (!this.state.firstAttempt) {
            this.setState({ loginOtherAttemptsButtonDisabled: !event.target.value });
        }
    }

    private handleLoginFirstStep(event: any) {
        console.log("[Login][handleLoginFirstStep] go to second step");
        event.preventDefault();
        this.setState({ usernameProvided: true });
        this.setState({ buttonDisabled: true });
    }

    private handleModifyUser(event: any) {
        console.log("[Login][handleModifyUser] modify user previously inserted!");
        event.preventDefault();
        this.setState({ usernameProvided: false });
        this.setState({ buttonDisabled: !this.state.username });
    }

    private goToRequestDev() {
        GoogleTagManagerService.getInstance().pushCta("richiedi utenza sviluppatore", "MuiButtonBase-root MuiButton-root MuiButton-text", "/activateDev");
        this.props.history.push("/registerDev");
    }

    private handleLogin(event: any) {
        console.log("[Login][handleLogin] do Login!");
        event.preventDefault();
        this.setState({ showLoader: true });
        this.recaptcha.getToken('login').then((recaptchaToken) => {
            console.log("[Login][handleLogin] recaptcha token: " + recaptchaToken);
            this.loginObservable = AuthService.getInstance().login(this.state.username, this.state.password, recaptchaToken).subscribe(result => {
                if (result === LoginApiState.LOGIN_SUCCESS) {
                    console.log("[Login][handleLogin] Login OK");

                    // Superuser Details
                    this.adminDetailSubscription = MposWebPortalApi.getInstance().getSuperUserDetails().subscribe((details) => {
                        this.setState({ showLoader: false });
                        this.setState({ superuserDetailsError: false });
                        this.goToHomePage();

                        // Get Terminals
                        this.getTerminalsSubscription = MposWebPortalApi.getInstance().getTerminals().subscribe((terminalsDto: ITerminalsDto) => {
                            StateContextProvider.getInstance().setProp('sameTerminalsType', TerminalsUtils.checkSameTerminalType(terminalsDto?.terminals))
                            StateContextProvider.getInstance().setProp('allTerminalsType', terminalsDto?.terminals?.length !== 0 ? terminalsDto?.terminals![0].terminalType : "")

                            const mPos = terminalsDto?.terminals?.filter((element: any) => element.terminalType === "MPOS");
                            const mPosActive = mPos?.filter((element: any) => element.tidStatus === "ATTIVO");
                            const sPos = terminalsDto?.terminals?.filter((element: any) => element.terminalType === "SOFTPOS");
                            const sPosActive = sPos?.filter((element: any) => element.tidStatus === "ATTIVO");

                            // Get Developers
                            this.getDevelopersSubscription = MposWebPortalApi.getInstance().getDevelopers().subscribe((result) => {
                                details.numberOfDevs = result.developers!.length
                                GoogleTagManagerService.getInstance().pushPageLogin(
                                    'login',
                                    {
                                        result: 'ok',
                                        message: null
                                    },
                                    details.contractCode,
                                    {
                                        total: mPos?.length,
                                        active: mPosActive?.length
                                    },
                                    {
                                        total: sPos?.length,
                                        active: sPosActive?.length
                                    },
                                    { total: details.numberOfUsers },
                                    details.numberOfDevs
                                );
                            }, (error) => {
                                console.log(error)
                            });
                        }, (error) => {
                            console.log("[Terminals] Error when try to fetch data! " + JSON.stringify(error));
                            StateContextProvider.getInstance().setProp('sameTerminalsType', false)
                        });
                    }, () => {
                        this.setState({ superuserDetailsError: true });
                        this.setState({ showLoader: false });
                    });
                } else if (result === LoginApiState.LOGIN_DEVELOPER_SUCCESS) {
                    this.userLogin = MposWebPortalApi.getInstance().userLogin().subscribe((payload: any) => {
                        StateContextProvider.getInstance().setProp('certificate', payload.certificate);
                    }, () => { });
                    this.setState({ showLoader: false });
                    this.goToHomePage();
                } else if (result === LoginApiState.LOGIN_CHANGE_PASSWORD) {
                    console.log("[Login][handleLogin] Handle change password...");
                    this.setState({ showLoader: false });
                    this.goToChangePasswordPage();
                } else if (result === LoginApiState.LOGIN_SUCCESS_WITH_SHOW_TC) {
                    console.log("[Login][handleLogin] Handle accept t&c...");
                    this.adminDetailSubscription = MposWebPortalApi.getInstance().getSuperUserDetails().subscribe((details) => {
                        this.setState({ showLoader: false });
                        this.setState({ superuserDetailsError: false });
                        this.goToHomePage();

                        // Get Terminals
                        this.getTerminalsSubscription = MposWebPortalApi.getInstance().getTerminals().subscribe((terminalsDto: ITerminalsDto) => {
                            StateContextProvider.getInstance().setProp('sameTerminalsType', TerminalsUtils.checkSameTerminalType(terminalsDto?.terminals))
                            StateContextProvider.getInstance().setProp('allTerminalsType', terminalsDto?.terminals?.length !== 0 ? terminalsDto?.terminals![0].terminalType : "")

                            const mPos = terminalsDto?.terminals?.filter((element: any) => element.terminalType === "MPOS");
                            const mPosActive = mPos?.filter((element: any) => element.tidStatus === "ATTIVO");
                            const sPos = terminalsDto?.terminals?.filter((element: any) => element.terminalType === "SOFTPOS");
                            const sPosActive = sPos?.filter((element: any) => element.tidStatus === "ATTIVO");

                            GoogleTagManagerService.getInstance().pushPageLogin(
                                'login',
                                {
                                    result: 'ok',
                                    message: null
                                },
                                details.contractCode,
                                {
                                    total: mPos?.length,
                                    active: mPosActive?.length
                                },
                                {
                                    total: sPos?.length,
                                    active: sPosActive?.length
                                },
                                { total: details.numberOfUsers },
                                details.numberOfDevs
                            );
                        }, (error) => {
                            console.log("[Terminals] Error when try to fetch data! " + JSON.stringify(error));
                            StateContextProvider.getInstance().setProp('sameTerminalsType', false)
                        });
                    }, () => {
                        this.setState({ superuserDetailsError: true });
                        this.setState({ showLoader: false });
                    });
                } else {
                    console.log("[Login][handleLogin] Login KO");
                    this.setLoginError();
                    this.setState({ loginErrorMessage: "Credenziali non corrette. Riprova" });
                    this.setState({ showLoader: false });
                    this.setState({ password: "" });
                    this.setState({ username: "" });
                    this.setState({ firstAttempt: false }, () => {
                        this.setState({ loginOtherAttemptsButtonDisabled: true });
                    });
                }
            }, error => {
                this.setState({ loginErrorMessage: "Il servizio non è disponibile. Riprova più tardi." });
                console.log("[Login][handleLogin] Login error: " + JSON.stringify(error));
                this.setLoginError();
                this.setState({ showLoader: false });
                this.setState({ password: "" });
                this.setState({ username: "" });
                this.setState({ firstAttempt: false }, () => {
                    this.setState({ loginOtherAttemptsButtonDisabled: true });
                });
            });
        }).catch(error => {
            console.log("[Login][handleLogin] recaptcha error: " + JSON.stringify(error));
            this.setState({ loginErrorMessage: "Il servizio non è disponibile. Riprova più tardi." });
            this.setLoginError();
            this.setState({ showLoader: false });
            this.setState({ password: "" });
            this.setState({ username: "" });
            this.setState({ firstAttempt: false }, () => {
                this.setState({ loginOtherAttemptsButtonDisabled: true });
            });
        });
    }

    private setLoginError() {
        this.setState({ loginError: true })
        this.setState({ buttonDisabled: true })
    }

    private goToHomePage() {
        this.props.history.push('/');
    }

    private goToChangePasswordPage() {
        this.props.history.push('/changePassword');
    }

    private goToTermsAndCondition() {
        this.props.history.push('/termsAndConditions', { fromHome: false });
    }

    componentWillUnmount() {
        if (this.loginObservable != null) {
            this.loginObservable.unsubscribe();
        }

        if (this.adminDetailSubscription != null) {
            this.adminDetailSubscription.unsubscribe();
        }

        if (this.getDevelopersSubscription != null) {
            this.getDevelopersSubscription.unsubscribe();
        }
    }

    render() {
        //@ts-ignore
        let supportLink = this.config.supportLink;
        return <div id={"login-mobile-main-container"} style={{ minHeight: this.isAndroid ? 'calc(100vh - 20px)' : 'calc(100vh - 96px)' }}>
            <div id={"login-mobile-main-content"}>
                {
                    [this.state.firstAttempt && <div id={"login-mobile-form-content"}>
                        <Media query="(max-width: 1064px)" render={() =>
                        (<div className={"login-mobile-help-icon-container"}>
                            <a href={supportLink}><HelpIcon className={"login-mobile-help-icon"} onClick={() => {
                                GoogleTagManagerService.getInstance().pushInteractionEvent('Click', 'assistenza', 'click', 'icon');
                            }} /></a>
                        </div>
                        )}
                        />
                        <h4 className={"login-mobile-form-title"}>Area riservata</h4>
                        <p className={"login-mobile-form-subtitle"}>Gestione Nexi POS</p>
                        {this.state.loginError &&
                            <p className={"login-mobile-error-msg-login-failed"}>{this.state.loginErrorMessage}</p>}
                        <div>
                            {
                                (!this.state.usernameProvided || this.state.loginError) &&
                                <div className={"login-mobile-form-fields"}>
                                    <TextField id="mobileUsernameField" label="Inserisci username Nexi POS"
                                        onChange={this.handleUsernameChanges} value={this.state.username}
                                        error={this.state.loginError}
                                        onFocus={() => {
                                            if (this.isAndroid) {
                                                let current = $("#login-mobile-main-container").height()!;
                                                $("#login-mobile-main-container").height(current);
                                            }
                                        }}
                                    />
                                </div>
                            }
                            {
                                this.state.usernameProvided && <div>
                                    {!this.state.loginError && <div className={"login-mobile-form-user-second-step"}>
                                        <p className={"login-mobile-username-field-title"}>Inserisci username Nexi POS</p>
                                        <p className={"login-mobile-username-field-value"}>{StringUtils.maskString(this.state.username!!)}</p>
                                        <Button id={"login-mobile-button-change"}
                                            onClick={this.handleModifyUser} disableRipple>MODIFICA</Button>
                                    </div>}
                                    <div className={this.state.loginError ? "login-mobile-form-fields login-mobile-margin-error" : "login-mobile-form-fields"}>
                                        <TextField id={"mobilePasswordField"} label="Inserisci la tua password" type={"password"}
                                            onChange={this.handlePasswordChanges}
                                            value={this.state.password} error={this.state.loginError}
                                            onFocus={() => {
                                                if (this.isAndroid) {
                                                    let current = $("#login-mobile-main-container").height()!;
                                                    $("#login-mobile-main-container").height(current);
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="box-text-credentials">
                            <p>
                                Non ricordi le tue credenziali? Recuperale dall’App Nexi POS.
                            </p>
                        </div>

                    </div>,
                    !this.state.firstAttempt && <div id={"login-mobile-form-content"}>
                        <Media query="(max-width: 1064px)" render={() =>
                        (<div className={"login-mobile-help-icon-container"}>
                            <a href={supportLink}><HelpIcon className={"login-mobile-help-icon"} onClick={() => {
                                GoogleTagManagerService.getInstance().pushInteractionEvent('Click', 'assistenza', 'click', 'icon');
                            }} /></a>
                        </div>
                        )}
                        />
                        <h4 className={"login-mobile-form-title"}>Area riservata</h4>
                        <p className={"login-mobile-form-subtitle"}>Gestione utenti Nexi POS</p>
                        <p className={this.state.loginError ? "login-mobile-error-msg-login-failed" : "login-mobile-error-msg-login-failed login-mobile-login-error-hidden"}>{this.state.loginErrorMessage}</p>
                        <div>
                            <div className={"login-mobile-form-fields"}>
                                <TextField id="mobileUsernameField" label="Inserisci username Nexi POS"
                                    onChange={this.handleUsernameChanges} value={this.state.username}
                                    error={this.state.loginError}
                                    onFocus={() => {
                                        if (this.isAndroid) {
                                            let current = $("#login-mobile-main-container").height()!;
                                            $("#login-mobile-main-container").height(current);
                                        }
                                    }}
                                />
                            </div>
                            <div className={"login-mobile-form-fields login-mobile-margin-error"}>
                                <TextField id={"mobilePasswordField"} label="Inserisci la tua password" type={"password"}
                                    onChange={this.handlePasswordChanges}
                                    value={this.state.password} error={this.state.loginError}
                                    onFocus={() => {
                                        if (this.isAndroid) {
                                            let current = $("#login-mobile-main-container").height()!;
                                            $("#login-mobile-main-container").height(current);
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>]
                }
                {
                    [this.state.firstAttempt && <div className={"login-mobile-button-submit-container"}>
                        <Button id={"login-mobile-submit-button"}
                            type={"button"}
                            onClick={!this.state.usernameProvided ? this.handleLoginFirstStep : this.handleLogin}
                            disabled={this.state.buttonDisabled}>AVANTI</Button>
                    </div>,
                    !this.state.firstAttempt && <div className={"login-mobile-button-submit-container"}>
                        <Button id={"login-mobile-submit-button"}
                            type={"button"}
                            onClick={this.handleLogin}
                            disabled={this.state.loginOtherAttemptsButtonDisabled}>AVANTI</Button>
                    </div>
                    ]
                }

                <p className="registerDev">Devi accedere all’area sviluppatore? <br /> <Button disableRipple onClick={() => {
                    this.goToRequestDev();
                }} className="registerDevUser">Richiedi account sviluppatore</Button></p>

                {
                    // @ts-ignore
                    <MposLoader show={this.state.showLoader} />
                }
            </div>
        </div>
    }
}